<div class="main-container">
  <h1>Select Lesson Plan Slot</h1>
  <p>
    Choose which activity you plan for this song/chant this week:
  </p>
  <div>
    <ion-list class="list">
      <ion-item>
        <ion-select
          [(ngModel)]="selectedActivity"
          (ionChange)="changed($event)"
          placeholder="Choose one"
          interface="popover"
        >
          <ion-select-option value="-1">&lt;Remove Song From Lesson Plan&gt;</ion-select-option>
          <ion-select-option
            *ngFor="let slot of lesson.songs; let i = index"
            [disabled]="isActivityDisabled(slot)"
            [value]="slot"
            >{{i+1}}. {{staticDataService?.getActivityDefaultText(i + 1, lesson, course)}}
          </ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
    <div class="buttons">
      <button class="cancel" [disabled]='waiting' (click)="cancel()">Cancel</button>
      <button class="submit" [disabled]='waiting || !hasValue' (click)="submit()">Submit</button>
    </div>
  </div>
</div>
